import { render, staticRenderFns } from "./FighterEdit.vue?vue&type=template&id=69965ecc&lang=pug"
import script from "./FighterEdit.vue?vue&type=script&lang=js"
export * from "./FighterEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports